var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.onlyOneLinkedProfile
    ? _c(
        "h2",
        { staticClass: "mb-0 clickable text-secondary" },
        [
          _c(
            "router-link",
            {
              attrs: {
                "aria-hidden": "true",
                "data-toggle": "tooltip",
                "data-placement": "top",
                "data-original-title": _vm.onlyOneLinkedTooltip,
                to: _vm.redirectLink(_vm.onlyOneLinkedProfile),
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.applicantName) + "\n  ")]
          ),
        ],
        1
      )
    : _c("div", [
        _c("div", { staticClass: "d-inline-flex dropdown" }, [
          _c(
            "h2",
            {
              staticClass: "mb-0 dropdown-toggle clickable",
              attrs: { "data-toggle": "dropdown" },
            },
            [_vm._v("\n      " + _vm._s(_vm.applicantName) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            _vm._l(_vm.linkedProfiles, function (linkedProfile, index) {
              return _c(
                "router-link",
                {
                  key: index,
                  staticClass: "clickable text-grey dropdown-item pb-2 mb-1",
                  attrs: { to: _vm.redirectLink(linkedProfile) },
                  on: {
                    click: function ($event) {
                      return _vm.handleDropdownAnchor(linkedProfile)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "bold" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(linkedProfile.givenName) +
                        " " +
                        _vm._s(linkedProfile.familyName) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-sm" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.value")) +
                        ":\n          " +
                        _vm._s(_vm.formatMoneyValue(linkedProfile.value)) +
                        "\n        "
                    ),
                  ]),
                ]
              )
            }),
            1
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }